import { render, staticRenderFns } from "./ConditionsGenerales.vue?vue&type=template&id=17210270"
import script from "./ConditionsGenerales.vue?vue&type=script&lang=ts"
export * from "./ConditionsGenerales.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports